import React from 'react';
import styled, { withTheme } from 'styled-components';
import { inject, observer } from 'mobx-react';

import { propStyles } from '../utils/propStyles';
import { HeaderElement } from '../models/configuration/header/HeaderLayout';
import { Theme } from '../models/Theme';
import { DataStore, FilterStore, ScreenSizeStore } from '../stores';

import Search from './Search';
import WatchListButton from './WatchListButton';
import ResizeDetector from './ResizeDetector';
import ExplorerDownload from './ExplorerDownload';
import FiltersToggle from './FiltersToggle';
import ClearFiltersButton from './ClearFiltersButton';

const HeaderLayoutWrapper = styled<any, any>(
    'header',
    'headerLayoutWrapper',
    'HeaderLayout'
)`
    ${propStyles};
    top: 0;
`;

HeaderLayoutWrapper.defaultProps = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'none none solid none',
    padding: 'lg',
};

interface HeaderLayoutProps {
    theme?: Theme;
    dataStore?: DataStore;
    filterStore?: FilterStore;
    screenSizeStore?: ScreenSizeStore;
}

@inject('dataStore', 'filterStore', 'screenSizeStore')
@observer
class HeaderLayout extends React.Component<HeaderLayoutProps> {
    constructor(props) {
        super(props);
    }

    renderComponent = ({ type, options }: HeaderElement) => {
        const { dataStore, filterStore } = this.props;

        switch (type) {
            case 'SEARCH':
                return (
                    <Search
                        key={type}
                        total={dataStore.total}
                        search={dataStore.searchValues}
                        onChange={dataStore.search}
                        clearSearch={dataStore.clearSearch}
                        {...options}
                    />
                );
            case 'WATCHLIST':
                return (
                    <WatchListButton
                        key={type}
                        onClick={dataStore.toggleWatchList}
                        active={dataStore.watchListActive}
                        count={dataStore.watchListCount}
                        {...options}
                    />
                );
            case 'DOWNLOAD':
                return (
                    <ResizeDetector
                        key={type}
                        handleWidth={true}
                        handleHeight={true}
                    >
                        <ExplorerDownload {...options} />
                    </ResizeDetector>
                );
            case 'TOGGLE_FILTERS':
                return (
                    <FiltersToggle
                        key={type}
                        onClick={filterStore.toggleFilters}
                        filtersActive={filterStore.filtersActive}
                        filtersCount={filterStore.filtersCount}
                        expanded={filterStore.filtersOpen}
                        {...options}
                    />
                );
            case 'CLEAR_FILTERS':
                return (
                    <ClearFiltersButton
                        key={type}
                        onClick={filterStore.clearFilters}
                        filtersActive={filterStore.filtersActive}
                        filtersCount={filterStore.filtersCount}
                        expanded={filterStore.filtersOpen}
                        {...options}
                    />
                );
            default:
                return null;
        }
    };

    render() {
        const { headerLayout } = this.props.screenSizeStore;
        return (
            <HeaderLayoutWrapper>
                {headerLayout.map(args => this.renderComponent(args))}
            </HeaderLayoutWrapper>
        );
    }
}

export default withTheme(HeaderLayout);



// WEBPACK FOOTER //
// ./src/Components/HeaderLayout.tsx